// Generic results view for the playable flow. Renders result.rows produced by a
// game's settle(): Pos | Player | <game columns> | $. Used by the point/holder
// games (Nines, Chicago, Dogfight, Rabbit, Stroke…) that don't need a bespoke
// board. result = { rows:[{ id, name, net, ...cols }], columns:[{key,label}] }.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }
const money = (v) => { const n = Math.round(Number(v) || 0); return n > 0 ? `+$${n}` : n < 0 ? `−$${Math.abs(n)}` : '$0' }

export default function GStandingsResults({ game, result }) {
  if (!result?.rows?.length) return <div className="card">No results yet — enter some scores.</div>
  const cols = result.columns || []
  const showMoney = result.rows.some((r) => Number(r.net) !== 0)
  return (
    <div className="card">
      <h3 className="font-extrabold mb-3" style={{ fontSize: 18 }}>{game?.meta?.name || 'Results'}</h3>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f6f6f2', color: '#555' }}>
            {['Pos', 'Player', ...cols.map((c) => c.label), ...(showMoney ? ['$'] : [])].map((h) => (
              <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {result.rows.map((r, i) => (
            <tr key={r.id}>
              <td style={cell}>{i + 1}</td>
              <td style={cell}>{r.name}</td>
              {cols.map((c) => <td key={c.key} style={cell}>{r[c.key]}</td>)}
              {showMoney && (
                <td style={cell}>
                  <b style={{ color: r.net > 0 ? '#1B7A3E' : r.net < 0 ? '#B42318' : '#374151' }}>{money(r.net)}</b>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
